import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
 const AutoScrollTop=()=>{
    const location = useLocation();

    useEffect(() => {
      // Scroll to top of the page whenever location changes
      window.scrollTo(0, 0);
    }, [location]); // Dependency on location to trigger on route change
  
    return null;
 }

 export default AutoScrollTop